import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import CryptoJS from "crypto-js";
import { v4 as uuidv4 } from "uuid";
import ICONS from "../../../assets/Icons";
import CommonToast from "../../../components/_utils/CommonToast";
import { env } from "../../../env";
import getServices from "../../../services/getServices";
import axiosInstance from "../../globalInspector/axiosInstance";
import { toast } from "react-toastify";

function encryptPassword(password, key) {
  const encryptedPassword = CryptoJS.HmacSHA256(password, key).toString();
  return encryptedPassword;
}

const getIPAdress = async () => {
  try {
    const ipAddress = await axiosInstance.get(
      "https://nxt.api.q2pay.in/api/utilities/whatismyip",
    );
    return ipAddress?.data?.ip;
  } catch (error) {
    CommonToast({
      text: error.response.data.errors.base[0],
      icon: ICONS?.ERROR_WHITE_CIRCLE,
      variant: "var(--error)",
      buttonNeeded: false,
    });
  }
};

async function getDeviceInfo() {
  const userAgent = window.navigator.userAgent;
  let browserName = "Unknown";
  let osVersion = "Unknown";

  if (userAgent.indexOf("Edg/") > -1) {
    browserName = "Microsoft Edge (Chromium)";
  } else if (userAgent.indexOf("Chrome") > -1) {
    browserName = "Google Chrome";
  } else if (userAgent.indexOf("Firefox") > -1) {
    browserName = "Mozilla Firefox";
  } else if (userAgent.indexOf("Safari") > -1) {
    browserName = "Apple Safari";
  } else if (
    userAgent.indexOf("MSIE") > -1 ||
    userAgent.indexOf("Trident/") > -1
  ) {
    browserName = "Microsoft Internet Explorer";
  } else if (userAgent.indexOf("Opera") > -1) {
    browserName = "Opera";
  }

  if (/iPhone|iPad|iPod/.test(userAgent)) {
    osVersion = "iOS";
  } else if (/Mac OS X/.test(userAgent) && !/like Mac OS X/.test(userAgent)) {
    osVersion = "macOS";
  } else if (userAgent.indexOf("Windows NT") !== -1) {
    osVersion = "Windows";
  } else if (userAgent.indexOf("Linux") !== -1) {
    osVersion = "Linux";
  } else if (userAgent.indexOf("Android") !== -1) {
    osVersion = "Android";
  }

  const ipAddress = await getIPAdress();

  return {
    uuid: uuidv4(),
    platform: "web",
    browser_name: browserName,
    ip_address: ipAddress,
    os_version: osVersion,
  };
}

export const loginNewToken = createAsyncThunk(
  "loginNewToken",
  async (values, { rejectWithValue }) => {
    const { user_Id, password, totp } = values;
    const key = env.REACT_APP_ENCRYPTION_KEY;
    const baseUrl = env.REACT_APP_BASE_URL;
    const encryptedPassword = encryptPassword(password, key);

    const deviceInfo = await getDeviceInfo();

    const requestBody = {
      identifier: user_Id,
      password: encryptedPassword,
      device_info: deviceInfo,
      totp: totp,
    };

    try {
      const response = await axiosInstance.post(
        `${baseUrl}/users/token`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

export const changePassword = createAsyncThunk(
  "changePassword",
  async (values, { rejectWithValue }) => {
    const { oldPassword, newPassword, confirmPassword, setButtonLoading } =
      values;

    const key = env.REACT_APP_ENCRYPTION_KEY;
    const baseUrl = env.REACT_APP_BASE_URL;
    const encryptedOldPassword = encryptPassword(oldPassword, key);
    const encryptedNewPassword = encryptPassword(newPassword, key);
    const encryptedConfirmPassword = encryptPassword(confirmPassword, key);

    const requestBody = {
      old_pwd: encryptedOldPassword,
      new_pwd1: encryptedNewPassword,
      new_pwd2: encryptedConfirmPassword,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/users/change_password`,
        requestBody,
        {
          headers: {
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      setButtonLoading(false);
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

export const checkUsertoken = createAsyncThunk(
  "checkUsertoken",
  async (values, { rejectWithValue }) => {
    // const baseUrl = env.REACT_APP_BASE_URL;
  },
);

export const getAllRoleFeatures = createAsyncThunk(
  "getAllRoleFeatures",
  async (values, { rejectWithValue }) => {
    const baseUrl = env.REACT_APP_BASE_URL;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/entities/users_for_role_assignment`,
        {
          headers: {
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

const loginSlice = createSlice({
  name: "login",
  initialState: {
    isLoading: false,
    data: null,
    services: null,
    new_services: null,
    q2p_token: null,
    isError: false,
    multipleEntity: false,
    entity: null,
    resetLoginModal: null,
    showReloginModal: false,
    loginErrorMessage: null,
    roleFeatures: [],
    changePasswordData: null,
    changePasswordLoading: false,
    changePasswordError: null,
    changePasswordErrorMessage: null,
  },
  reducers: {
    setEntity: (state, action) => {
      let data = [action.payload];
      state.entity = data;
    },
    setMultipleEntity: (state) => {
      state.entity = null;
    },
    setShowReloginModal: (state) => {
      state.showReloginModal = true;
    },
    setShowReloginModalFalse: (state) => {
      state.showReloginModal = false;
    },
    resetFirstLoginData: (state) => {
      state.data = null;
    },
    resetLoginModalstate: (state) => {
      state.resetLoginModal = null;
    },
    resetLoginError: (state) => {
      state.isError = null;
      state.loginErrorMessage = null;
    },
    resetChangePassword: (state) => {
      state.changePasswordData = null;
      state.changePasswordLoading = false;
      state.changePasswordError = null;
      state.changePasswordErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginNewToken.pending, (state, action) => {
      state.isLoading = true;
      state.resetLoginModal = "loading";
    });
    builder.addCase(loginNewToken.fulfilled, (state, action) => {
      state.isLoading = false;
      state.showReloginModal = false;
      state.resetLoginModal = "fulfilled";
      if (
        Array.isArray(action?.payload?.entity) &&
        action?.payload?.entity?.length > 1
      ) {
        state.multipleEntity = true;
      } else {
        state.entity = action.payload.entity;
      }
      sessionStorage.setItem("response", JSON.stringify(action.payload));
      sessionStorage.setItem("user_id", action.payload?.employees?.user_id);
      sessionStorage.setItem(
        "first_name",
        action.payload?.employees?.first_name,
      );
      sessionStorage.setItem("entity_id", action.payload?.entity?.entity_id);
      sessionStorage.setItem("loggedIn", true);
      state.services = Object.keys(
        getServices(action.payload.services).services_list,
      );
      state.data = action.payload;
      state.q2p_token = action.payload.q2p_token;
      state.new_services = Object.keys(
        getServices(action.payload.services).services_list,
      );
      window.sessionStorage.setItem("q2p_token", action.payload.q2p_token);
      window.sessionStorage.setItem("tokenGenerated", "false");
    });
    builder.addCase(loginNewToken.rejected, (state, action) => {
      if (action?.payload?.errors?.user_unauthorized) {
        CommonToast({
          text: action.payload?.errors?.user_unauthorized[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else if (action?.payload?.errors?.base) {
        if (action?.payload?.errors?.base[0] === "Your account is Blocked") {
          CommonToast({
            text: action?.payload?.errors?.base[0],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
        state.loginErrorMessage = action?.payload?.errors?.base[0];
      }
      state.showReloginModal = "Error";
      state.resetLoginModal = "Error";
      state.isError = true;
      state.isLoading = false;
      state.data = null;
    });
    builder.addCase(changePassword.fulfilled, (state, action) => {
      state.changePasswordLoading = false;
      state.changePasswordData = action?.payload;
    });
    builder.addCase(changePassword.pending, (state, action) => {
      state.changePasswordLoading = true;
      state.changePasswordError = false;
    });
    builder.addCase(changePassword.rejected, (state, action) => {
      if (action?.payload?.errors?.user_unauthorized) {
        toast.dismiss();
        CommonToast({
          text: action.payload?.errors?.user_unauthorized[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else if (action?.payload?.errors?.base) {
        toast.dismiss();
        state.changePasswordErrorMessage = action?.payload?.errors?.base[0];
        CommonToast({
          text: action?.payload?.errors?.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
      state.changePasswordLoading = true;
      state.changePasswordError = true;
    });
    builder.addCase(checkUsertoken.rejected, (state, action) => {
      if (action?.payload?.errors?.user_unauthorized) {
        if (sessionStorage.getItem("loggedIn")) {
          state.showReloginModal = true;
        }
      }
    });
    builder.addCase(getAllRoleFeatures.pending, (state) => {
      state.isLoading = true;
      state.isError = null;
    });
    builder.addCase(getAllRoleFeatures.fulfilled, (state, action) => {
      state.isLoading = false;
      state.roleFeatures = action.payload;
      if (!action.payload.employees || action.payload.employees.length === 0) {
        state.noUsersFound = true;
      } else {
        state.noUsersFound = false;
      }
    });
    builder.addCase(getAllRoleFeatures.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = action.payload;
    });
  },
});
export const {
  setEntity,
  setMultipleEntity,
  setShowReloginModal,
  resetFirstLoginData,
  setShowReloginModalFalse,
  resetLoginModalstate,
  resetLoginError,
  resetChangePassword,
} = loginSlice.actions;
export default loginSlice.reducer;
